import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDfDL7ckZtjkDmgKBierKY9MnEcF3yst1c",
  authDomain: "tejati-index.firebaseapp.com",
  projectId: "tejati-index",
  storageBucket: "tejati-index.firebasestorage.app",
  messagingSenderId: "753395162095",
  appId: "1:753395162095:web:b8a06bc48a30eff07a741a",
  measurementId: "G-DZ9WP1537Q"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);
const googleProvider = new GoogleAuthProvider();

export { db, auth, googleProvider, functions };
